module.exports = __webpack_public_path__ + "fonts/rubik-regular-webfont.20a58690.20a58690.ttf";